<template>
  <v-select
    class="select-custom"
    v-model="selected"
    v-if="options.length"
    :options="options"
    :multiple="isMultiple"
    :searchable="isSearchable"
    :placeholder="translations.placeholder"
    :onChange="setActiveFilters"
  >
    <span slot="no-options">
      {{ translations.noResults }}
    </span>
    <template slot="option" slot-scope="option">
      {{ option.label }}
    </template>
  </v-select>
  <div class="dropdown v-select select-custom single" v-else>
    <div class="dropdown-toggle clearfix">
      <span class="dropdown-toggle-fakeinput">
        {{ translations.noResults }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'selectCustom',
  props: {
    options: Array,
    isSelected: Object,
    isMultiple: null,
    isSearchable: Boolean,
    filterID: String,
    translations: Object,
    getActiveFilter: Array
  },
  data: function () {
    return {
      selected: this.isSelected,
      filtersObj: this.$store.state.activeFilters
    }
  },
  methods: {
    setActiveFilters (val) {
      let filterValues = []

      if (this.filterID === 'select-category' && val.value !== this.activeCategoryName) {
        let categoryQuery = (this.$route.query.kategoria === val.value ? Object.assign({}, this.$route.query, { 'kategoria': val.value }) : { 'kategoria': val.value })
        this.$store.state.activeCategoryName = val.value
        this.$router.push({
          'name': 'search',
          'query': categoryQuery
        })
      } else {
        if (val) {
          let valuesArr = (!val.length ? [val] : val)
          valuesArr.map((item) => {
            if (item.value && !filterValues.includes(encodeURIComponent(item.value))) {
              filterValues.push([encodeURIComponent(item.value), (item.label ? item.label : encodeURIComponent(item.value))])
            }
          })
        }
        this.filtersObj[this.filterID] = filterValues
        this.$store.commit('setActiveFilters', this.filtersObj)
      }
    },
    checkActiveFilters (id) {
      return (id && id !== 'select-category' && this.getActiveFilter ? this.getActiveFilter : this.isSelected)
    }
  },
  comupted: {
    store () {
      return this.$store.state
    }
  },
  mounted () {
    this.selected = this.checkActiveFilters(this.filterID)
  },
  updated () {
    this.selected = this.checkActiveFilters(this.filterID)

    this.$nextTick(() => {
      this.selected = this.checkActiveFilters(this.filterID)
    })
  }
}
</script>

<style lang="scss">
  .select-custom.v-select {

    &.open {
      &:before {
        @include after(0, 4px, 0, auto, 40px, 10);
        background-color: $text-dark;
        bottom: 0;

        #app.hight-contrast & {
          background: $contrast-text;
        }
      }
    }

    .dropdown-menu {
      border: 0 none;
      border-radius: 0;
      box-shadow: none;
      background: $base-light2;
      max-height: 216px !important;
      margin-left: ($gap-md * -1);
      margin-right: ($gap-md * -1);
      overflow-y: auto;
      padding: $gap-md;
      width: calc(100% + #{($gap-md * 2)});

      &::-webkit-scrollbar {
        background: $dropdown-scroll-bg;
        width: $dropdown-scroll-width;
      }

      &::-webkit-scrollbar-thumb {
        background: $dropdown-scroll-color;
        border-radius: $dropdown-scroll-radius;
      }
      .dark & {
        background: $contrast-bg;

        &::-webkit-scrollbar {
          background: $dropdown-scroll-contrast-bg;
        }

        &::-webkit-scrollbar-thumb {
          background: $dropdown-scroll-contrast-color;
        }
        &:before {
          background-color: $text-light;
        }
      }

      li {
        font: {
          family: $font-family;
          size: $font-s;
          weight: 500;
        }
        text-align: left;

        .font-size-l & {
          font-size: $font-m;
        }

        &.no-options {
          padding: $gap-xs 0;
        }

        a {
          color: $color-text;
          // padding: ($gap-xs / 2) 0;
          padding: ($gap-xs / 2) 0 ($gap-xs / 2) $gap-md;
          position: relative;

          // .input-wrapper-manufacturer & {
            // padding: ($gap-xs / 2) 0 ($gap-xs / 2) $gap-md;

            &:before {
              @include after(0, 9px, -5px 0 0 0, 50%, 9px, 10);
              background: transparent;
              border: 2px solid $color-text;

              #app.hight-contrast & {
                border-color: $contrast-accent;
              }

            }
          // } // END .input-wrapper-manufacturer &;

          #app.hight-contrast & {
            color: $contrast-accent;

            &:hover, &:focus {
              color: $contrast-text;
            }
          }
        } // END a;
      } // END li

      & > .highlight > a,
      & > .active > a {
        color: $text-accent;
        background: transparent;
      }
      & > .highlight > a {

        // .input-wrapper-manufacturer & {
          &:before {
            border-color: $text-accent;

            #app.hight-contrast & {
              border-color: $contrast-text;
            }
          }
        // } // END .input-wrapper-manufacturer &;

      }
      & > .active > a {

        // .input-wrapper-manufacturer & {
          &:before {
            background: $text-accent;
            border-color: $text-accent;

            #app.hight-contrast & {
              background: $contrast-accent;
              border-color: $contrast-accent;
            }
          }
        // } // END .input-wrapper-manufacturer &;

      }
    }
    .selected-tag {
      align-items: center;
      color: $text-accent;
      background-color: transparent;
      border: 0 none;
      border-radius: 0;
      display: flex;
      flex-flow: row nowrap;
      height: $input-height;
      line-height: 1.2em;
      margin: 4px 0 0 0;
      padding: 0 $gap-sm 0 0;
      float: left;
      font: {
        size: $font-m;
        weight: 700;
      }
      letter-spacing: 0;

      .font-size-l & {
        font-size: $font-l;
      }

      .dark & {
        color: $contrast-accent;
      }
    }
    .selected-tag .close {
      margin-left: 6px;
      font-size: $font-m;
      opacity: 0.35;
      text-shadow: none;

      &:hover,&:focus{
        opacity: 1;
      }
    }
    .open-indicator {
      right: 0;

      &:before {
        border: {
          color: $color-text;
          width: 2px 2px 0 0;
        }
        height: 9px;
        width: 9px;

        .dark & {
          border-color: $contrast-accent;
        }
      }
    }

    &.single {

      .dropdown-menu {
        li {
          a {
            padding: ($gap-xs / 2) 0;

            &:before {
              display: none;
            }
          }
        }
      } // END .dropdown-menu;

      .filters-header & {

        .form-control {
          left: 0;
          height: 100%;
          position: absolute;
          top: 0;
          width: 100%;
        }
        .clear {
          display: none;
        }
        .dropdown-toggle {
          border: 0 none;
          min-height: ($lh-xl + $gap-xs);
          padding: 0 0 $gap-xs 0;

          @include mobile {
            min-height: ($lh-xl-mobile + $gap-xs);
          }
        }
        .selected-tag {
          font-size: $font-xl;
          line-height: $lh-xl;
          margin: 0;
          text-transform: lowercase;

          .font-size-l & {
            font-size: 32px;
          }

          @include mobile {
            font-size: $font-xl-mobile;
            line-height: $lh-xl-mobile;
          }
        }
        .open-indicator {
          transform: translateY(#{($lh-l-mobile * -1)});

          @include screen('sm') {
            transform: translateY(0);
          }
        }

        &.open {
          .selected-tag {
            position: relative;
          }
        }

      } // END .filters-header &;
    } // END .select-custom.v-select.single;

    &.unsearchable {
      .dropdown-toggle {
        input {
          width: auto;
        }
      }
    } // END .select-custom.v-select.unsearchable

  } // END .select-custom.v-select;
</style>
